<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>{{ data.examType == 1 ? '교육' : '시험' }} 취소 신청</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl">
                    <p>예금주</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="이름을 입력해 주세요"
                        v-model="form.accountName"
                      />
                      <p
                        class="valid"
                        :class="{ on: $v.form.accountName.$error }"
                      >
                        이름을 입력해주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>은행명</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="은행명을 입력해 주세요"
                        v-model="form.bank"
                      />
                      <p class="valid" :class="{ on: $v.form.bank.$error }">
                        은행명을 입력해주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>계좌번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="-를 제외하고 입력해 주세요"
                        v-model="form.account"
                        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                        inputmode="decimal" pattern="[0-9]*"
                      />
                      <p class="valid" :class="{ on: $v.form.account.$error }">
                        계좌번호를 입력해주세요.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
              </ul>
              <div class="inform_box center white">
                <div>
                  정확한 정보 입력 후 환불신청하시기 바라며,<br />
                  정보 오기재 시 환불 기간이 지연될 수 있습니다.<br />
                  <span class="small color"
                    >※ 취소 후 환불되기까지 약 2~7일 정도 소요됩니다.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="$emit('eventClose')">
                이전으로
              </button>
              <button class="btn" @click="fnComplete">취소 신청하기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'modal-edu-cancel-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      required: true
    }
  },
  data: function() {
    return {
      form: {
        accountName: '',
        bank: '',
        account: ''
      }
    }
  },
  validations: {
    form: {
      accountName: { required },
      bank: { required },
      account: { required }
    }
  },
  methods: {
    fnComplete: async function(e) {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      this.form.userExaminationNo = this.data.userExaminationNo
      const res = await this.$ManagerSvc.patchIntExamCancel(this.form)
      if (res.code === 1) {
        alert('접수되었습니다.')
      } else {
        await this.callBack(e, this.form)
      }
      this.$emit('eventClose')
    }
  }
}
</script>

<style scoped></style>
